"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constants = require("../constants");
var _Label = _interopRequireDefault(require("../Label"));
var _ToggleSwitch = _interopRequireDefault(require("./ToggleSwitch.style"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let ToggleSwitch = (_dec = (0, _reactJss.default)(_ToggleSwitch.default), _dec(_class = class ToggleSwitch extends _react.PureComponent {
  // Warning: In the new library version -
  // add inner value state to avoid writing external state for each ToggleSwitch usage
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      id,
      value,
      visibility,
      onChange,
      required
    } = this.props;
    if (visibility === 'disabled') return;
    const valueF = !_utils.default.tryToBool(value);
    const error = required && !valueF;
    onChange({
      id,
      value: valueF,
      error
    });
  }

  // render helper message
  renderHelperText(error, helperText, classes) {
    if (!helperText) return null;
    return /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.helperText),
      value: helperText,
      error: error,
      fontSize: "small"
    });
  }
  render() {
    const {
      classes,
      className,
      id,
      size,
      spaceSize,
      visibility,
      value,
      error,
      helperText,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      "data-testid": dataTestId ? `${dataTestId}-container` : undefined
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.row, {
        [spaceSize]: true
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(className, classes.switchWrap, classes[size], {
        active: !!value
      }, {
        disabled: visibility === 'disabled'
      }, {
        hidden: visibility === 'hidden'
      }, {
        error: !!error
      }),
      onClick: this.handleChange,
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.switch, {
        active: !!value
      }, {
        error: !!error
      })
    })), this.props.label), this.renderHelperText(error, helperText, classes));
  }
}) || _class);
ToggleSwitch.spaceSize = {
  xxsmall: _constants.SPACE_SIZE.xxsmall,
  xsmall: _constants.SPACE_SIZE.xsmall,
  small: _constants.SPACE_SIZE.small
};
ToggleSwitch.defaultProps = {
  visibility: 'visible',
  error: false,
  value: false,
  size: 'medium',
  spaceSize: _constants.SPACE_SIZE.xsmall,
  onChange: () => {}
};
var _default = exports.default = ToggleSwitch;